<template>
  <div>
    <Import
      title="Exchange Rate"
      @redirectPage="redirectPage"
      :check_validation="'currency/importexchangeratevalidation'"
      :url="url"
      :items="items"
      @import="submit"
      :show_message="''"
      :sample_file_name="'sample-exchange-rate-data.xlsx'"
      :show_dup_handle="{
        show:false,
        value:1}"
    ></Import>
  </div>
</template>
<script>
import Import from "@/components/Form/Import/Import";
import sample_data from "@/assets/sample-import-files/sample-exchange-rate.xlsx";
import { mapState } from "vuex";
export default {
  components: { Import, sample_data },
  data() {
    return {
      url: sample_data,
      items: this.import_columns()
    };
  },
  created() {},
  methods: {
    redirectPage() {
      this.$router.push({
        name: "Currency"
      });
    },
    import_columns() {
      return [
        {
          actual_label: "Currency Code",
          excel_label: "",
          field_name: "currency_code",
          is_required: true,
          unique: 0,
          datatype: "select",
          max: 0,
          min: 0
        },
        {
          actual_label: "Date",
          excel_label: "",
          field_name: "exchange_rate_date",
          is_required: true,
          unique: 1,
          datatype: "date",
          max: 0,
          min: 0
        },
        {
          actual_label: "Exchange Rate",
          excel_label: "",
          field_name: "value",
          is_required: true,
          unique: 0,
          datatype: "amount",
          max: 100000000000000,
          min: 0
        }
      ];
    },
    submit() {
      this.$store
        .dispatch("currency/importExchangeRate", this.list)
        .then(() => {
          this.$router.push({
            name: "Currency"
          });
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message,
            type: "success",
            showCloseButton: true
          });
        });
    }
  },
  computed: {
    ...mapState({
      message: state => state.currency.message,
      list: state => state.currency.list
    })
  }
};
</script>